"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetExpiration = exports.Dataset = exports.CPDT = exports.Table = exports.serviceStatusToJSON = exports.serviceStatusFromJSON = exports.ServiceStatus = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const timestamp_1 = require("../../google/protobuf/timestamp");
exports.protobufPackage = "glitterchain.index";
var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus[ServiceStatus["Service_Status_Unset"] = 0] = "Service_Status_Unset";
    ServiceStatus[ServiceStatus["Service_Status_Start"] = 1] = "Service_Status_Start";
    ServiceStatus[ServiceStatus["Service_Status_Stop"] = 2] = "Service_Status_Stop";
    ServiceStatus[ServiceStatus["Service_Status_Delete"] = 3] = "Service_Status_Delete";
    ServiceStatus[ServiceStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ServiceStatus = exports.ServiceStatus || (exports.ServiceStatus = {}));
function serviceStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "Service_Status_Unset":
            return ServiceStatus.Service_Status_Unset;
        case 1:
        case "Service_Status_Start":
            return ServiceStatus.Service_Status_Start;
        case 2:
        case "Service_Status_Stop":
            return ServiceStatus.Service_Status_Stop;
        case 3:
        case "Service_Status_Delete":
            return ServiceStatus.Service_Status_Delete;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ServiceStatus.UNRECOGNIZED;
    }
}
exports.serviceStatusFromJSON = serviceStatusFromJSON;
function serviceStatusToJSON(object) {
    switch (object) {
        case ServiceStatus.Service_Status_Unset:
            return "Service_Status_Unset";
        case ServiceStatus.Service_Status_Start:
            return "Service_Status_Start";
        case ServiceStatus.Service_Status_Stop:
            return "Service_Status_Stop";
        case ServiceStatus.Service_Status_Delete:
            return "Service_Status_Delete";
        default:
            return "UNKNOWN";
    }
}
exports.serviceStatusToJSON = serviceStatusToJSON;
const baseTable = { tableName: "", meta: "", description: "" };
exports.Table = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tableName !== "") {
            writer.uint32(10).string(message.tableName);
        }
        if (message.meta !== "") {
            writer.uint32(18).string(message.meta);
        }
        if (message.description !== "") {
            writer.uint32(26).string(message.description);
        }
        if (message.updateTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.updateTime), writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseTable);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tableName = reader.string();
                    break;
                case 2:
                    message.meta = reader.string();
                    break;
                case 3:
                    message.description = reader.string();
                    break;
                case 4:
                    message.updateTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseTable);
        if (object.tableName !== undefined && object.tableName !== null) {
            message.tableName = String(object.tableName);
        }
        else {
            message.tableName = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = String(object.meta);
        }
        else {
            message.meta = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = String(object.description);
        }
        else {
            message.description = "";
        }
        if (object.updateTime !== undefined && object.updateTime !== null) {
            message.updateTime = fromJsonTimestamp(object.updateTime);
        }
        else {
            message.updateTime = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.tableName !== undefined && (obj.tableName = message.tableName);
        message.meta !== undefined && (obj.meta = message.meta);
        message.description !== undefined && (obj.description = message.description);
        message.updateTime !== undefined && (obj.updateTime = message.updateTime.toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseTable);
        if (object.tableName !== undefined && object.tableName !== null) {
            message.tableName = object.tableName;
        }
        else {
            message.tableName = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = object.meta;
        }
        else {
            message.meta = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = object.description;
        }
        else {
            message.description = "";
        }
        if (object.updateTime !== undefined && object.updateTime !== null) {
            message.updateTime = object.updateTime;
        }
        else {
            message.updateTime = undefined;
        }
        return message;
    },
};
const baseCPDT = { datasetName: "", consumerAddress: "", amount: "" };
exports.CPDT = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.datasetName !== "") {
            writer.uint32(10).string(message.datasetName);
        }
        if (message.consumerAddress !== "") {
            writer.uint32(18).string(message.consumerAddress);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCPDT);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.datasetName = reader.string();
                    break;
                case 2:
                    message.consumerAddress = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCPDT);
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = String(object.datasetName);
        }
        else {
            message.datasetName = "";
        }
        if (object.consumerAddress !== undefined && object.consumerAddress !== null) {
            message.consumerAddress = String(object.consumerAddress);
        }
        else {
            message.consumerAddress = "";
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = String(object.amount);
        }
        else {
            message.amount = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.datasetName !== undefined && (obj.datasetName = message.datasetName);
        message.consumerAddress !== undefined && (obj.consumerAddress = message.consumerAddress);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseCPDT);
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = object.datasetName;
        }
        else {
            message.datasetName = "";
        }
        if (object.consumerAddress !== undefined && object.consumerAddress !== null) {
            message.consumerAddress = object.consumerAddress;
        }
        else {
            message.consumerAddress = "";
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = object.amount;
        }
        else {
            message.amount = "";
        }
        return message;
    },
};
const baseDataset = {
    datasetName: "",
    workStatus: 0,
    ownerAddress: "",
    hosts: "",
    manageAddresses: "",
    sumCpdt: "",
    meta: "",
    description: "",
};
exports.Dataset = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.datasetName !== "") {
            writer.uint32(10).string(message.datasetName);
        }
        if (message.workStatus !== 0) {
            writer.uint32(16).int32(message.workStatus);
        }
        if (message.ownerAddress !== "") {
            writer.uint32(26).string(message.ownerAddress);
        }
        if (message.expirationTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expirationTime), writer.uint32(34).fork()).ldelim();
        }
        if (message.hosts !== "") {
            writer.uint32(42).string(message.hosts);
        }
        if (message.manageAddresses !== "") {
            writer.uint32(50).string(message.manageAddresses);
        }
        for (const v of message.tables) {
            exports.Table.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.sumCpdt !== "") {
            writer.uint32(66).string(message.sumCpdt);
        }
        if (message.meta !== "") {
            writer.uint32(74).string(message.meta);
        }
        if (message.description !== "") {
            writer.uint32(82).string(message.description);
        }
        if (message.updateTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.updateTime), writer.uint32(90).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDataset);
        message.tables = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.datasetName = reader.string();
                    break;
                case 2:
                    message.workStatus = reader.int32();
                    break;
                case 3:
                    message.ownerAddress = reader.string();
                    break;
                case 4:
                    message.expirationTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.hosts = reader.string();
                    break;
                case 6:
                    message.manageAddresses = reader.string();
                    break;
                case 7:
                    message.tables.push(exports.Table.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.sumCpdt = reader.string();
                    break;
                case 9:
                    message.meta = reader.string();
                    break;
                case 10:
                    message.description = reader.string();
                    break;
                case 11:
                    message.updateTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDataset);
        message.tables = [];
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = String(object.datasetName);
        }
        else {
            message.datasetName = "";
        }
        if (object.workStatus !== undefined && object.workStatus !== null) {
            message.workStatus = serviceStatusFromJSON(object.workStatus);
        }
        else {
            message.workStatus = 0;
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        if (object.expirationTime !== undefined && object.expirationTime !== null) {
            message.expirationTime = fromJsonTimestamp(object.expirationTime);
        }
        else {
            message.expirationTime = undefined;
        }
        if (object.hosts !== undefined && object.hosts !== null) {
            message.hosts = String(object.hosts);
        }
        else {
            message.hosts = "";
        }
        if (object.manageAddresses !== undefined && object.manageAddresses !== null) {
            message.manageAddresses = String(object.manageAddresses);
        }
        else {
            message.manageAddresses = "";
        }
        if (object.tables !== undefined && object.tables !== null) {
            for (const e of object.tables) {
                message.tables.push(exports.Table.fromJSON(e));
            }
        }
        if (object.sumCpdt !== undefined && object.sumCpdt !== null) {
            message.sumCpdt = String(object.sumCpdt);
        }
        else {
            message.sumCpdt = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = String(object.meta);
        }
        else {
            message.meta = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = String(object.description);
        }
        else {
            message.description = "";
        }
        if (object.updateTime !== undefined && object.updateTime !== null) {
            message.updateTime = fromJsonTimestamp(object.updateTime);
        }
        else {
            message.updateTime = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.datasetName !== undefined && (obj.datasetName = message.datasetName);
        message.workStatus !== undefined && (obj.workStatus = serviceStatusToJSON(message.workStatus));
        message.ownerAddress !== undefined && (obj.ownerAddress = message.ownerAddress);
        message.expirationTime !== undefined && (obj.expirationTime = message.expirationTime.toISOString());
        message.hosts !== undefined && (obj.hosts = message.hosts);
        message.manageAddresses !== undefined && (obj.manageAddresses = message.manageAddresses);
        if (message.tables) {
            obj.tables = message.tables.map((e) => (e ? exports.Table.toJSON(e) : undefined));
        }
        else {
            obj.tables = [];
        }
        message.sumCpdt !== undefined && (obj.sumCpdt = message.sumCpdt);
        message.meta !== undefined && (obj.meta = message.meta);
        message.description !== undefined && (obj.description = message.description);
        message.updateTime !== undefined && (obj.updateTime = message.updateTime.toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDataset);
        message.tables = [];
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = object.datasetName;
        }
        else {
            message.datasetName = "";
        }
        if (object.workStatus !== undefined && object.workStatus !== null) {
            message.workStatus = object.workStatus;
        }
        else {
            message.workStatus = 0;
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        if (object.expirationTime !== undefined && object.expirationTime !== null) {
            message.expirationTime = object.expirationTime;
        }
        else {
            message.expirationTime = undefined;
        }
        if (object.hosts !== undefined && object.hosts !== null) {
            message.hosts = object.hosts;
        }
        else {
            message.hosts = "";
        }
        if (object.manageAddresses !== undefined && object.manageAddresses !== null) {
            message.manageAddresses = object.manageAddresses;
        }
        else {
            message.manageAddresses = "";
        }
        if (object.tables !== undefined && object.tables !== null) {
            for (const e of object.tables) {
                message.tables.push(exports.Table.fromPartial(e));
            }
        }
        if (object.sumCpdt !== undefined && object.sumCpdt !== null) {
            message.sumCpdt = object.sumCpdt;
        }
        else {
            message.sumCpdt = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = object.meta;
        }
        else {
            message.meta = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = object.description;
        }
        else {
            message.description = "";
        }
        if (object.updateTime !== undefined && object.updateTime !== null) {
            message.updateTime = object.updateTime;
        }
        else {
            message.updateTime = undefined;
        }
        return message;
    },
};
const baseDatasetExpiration = { datasetNames: "" };
exports.DatasetExpiration = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.datasetNames) {
            writer.uint32(10).string(v);
        }
        if (message.expirationTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expirationTime), writer.uint32(90).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDatasetExpiration);
        message.datasetNames = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.datasetNames.push(reader.string());
                    break;
                case 11:
                    message.expirationTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDatasetExpiration);
        message.datasetNames = [];
        if (object.datasetNames !== undefined && object.datasetNames !== null) {
            for (const e of object.datasetNames) {
                message.datasetNames.push(String(e));
            }
        }
        if (object.expirationTime !== undefined && object.expirationTime !== null) {
            message.expirationTime = fromJsonTimestamp(object.expirationTime);
        }
        else {
            message.expirationTime = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.datasetNames) {
            obj.datasetNames = message.datasetNames.map((e) => e);
        }
        else {
            obj.datasetNames = [];
        }
        message.expirationTime !== undefined && (obj.expirationTime = message.expirationTime.toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDatasetExpiration);
        message.datasetNames = [];
        if (object.datasetNames !== undefined && object.datasetNames !== null) {
            for (const e of object.datasetNames) {
                message.datasetNames.push(e);
            }
        }
        if (object.expirationTime !== undefined && object.expirationTime !== null) {
            message.expirationTime = object.expirationTime;
        }
        else {
            message.expirationTime = undefined;
        }
        return message;
    },
};
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=dataset.js.map